import { forwardRef, useCallback } from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconFilledProps, IconRender } from '../types.ts';

const Play = forwardRef<SVGSVGElement | null, IconFilledProps>(function Play({ filled, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          d='M16.625 13.0827C17.4583 12.6016 17.4583 11.3987 16.625 10.9176L10.625 7.45351C9.79167 6.97239 8.75 7.57379 8.75 8.53604L8.75 15.4642C8.75 16.4265 9.79167 17.0279 10.625 16.5468L16.625 13.0827ZM10.25 8.96906L15.5 12.0001L10.25 15.0312V8.96906Z'
          fill={filled ? 'transparent' : color}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M19.0711 19.0711C22.9763 15.1658 22.9763 8.83417 19.0711 4.92893C15.1658 1.02369 8.83417 1.02369 4.92893 4.92893C1.02369 8.83418 1.02369 15.1658 4.92893 19.0711C8.83418 22.9763 15.1658 22.9763 19.0711 19.0711ZM18.0104 18.0104C21.3299 14.691 21.3299 9.30905 18.0104 5.98959C14.691 2.67014 9.30905 2.67014 5.98959 5.98959C2.67014 9.30905 2.67014 14.691 5.98959 18.0104C9.30905 21.3299 14.691 21.3299 18.0104 18.0104Z'
          fill={filled ? 'transparent' : color}
        />
        {/* filled */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M19.0711 19.0711C15.1658 22.9763 8.83417 22.9763 4.92893 19.0711C1.02369 15.1658 1.02369 8.83418 4.92893 4.92893C8.83418 1.02369 15.1658 1.02369 19.0711 4.92893C22.9763 8.83418 22.9763 15.1658 19.0711 19.0711ZM15.4699 12.9182C16.1767 12.5101 16.1767 11.4899 15.4699 11.0818L10.3808 8.14363C9.67397 7.73554 8.79045 8.24565 8.79045 9.06181V14.9382C8.79045 15.7544 9.67397 16.2645 10.3808 15.8564L15.4699 12.9182Z'
          fill={filled ? color : 'transparent'}
        />
      </>
    ),
    [filled],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'play-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Play;
